/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as o}from"../../../../webgl/Uniform.js";class r extends o{constructor(o,r,s){super(o,"float",0,(t,e)=>t.setUniform1f(o,r(e),s))}}export{r as FloatBindUniform};
